<template>
  <div v-if="page">
    <section
      class="category_top_banner category_top_banner-sales cover"
      :style="[fields_acf.background_img ? { backgroundImage: 'url(' + fields_acf.background_img.desktop.url + ')' } : {}]"
    >
      <div class="container">
        <div class="mobile_only">
          <div
            class="absolute mobile_banner cover"
            :style="[fields_acf.background_img ? { backgroundImage: 'url(' + fields_acf.background_img.mobile.url + ')' } : {}]"
          ></div>
          <div class="bn_corner"></div>
        </div>
      </div>
    </section>
     <section class=" hp_products">
        <div class="container">
          <h2 class="title center">{{fields_acf.main_sale_title}}</h2>
          <div class=" row flex flex--start">
            <template v-for="(product, index) in fields_acf.main_sale_products">
              <Product  ref="productComponent" v-bind:product="product" v-bind:index="index" :key="product.id"></Product>
            </template>
          </div>
        </div>
      </section>
    <!-- <section class="no_mobile cat_sales_wrap" v-if="$mq !== 'mobile'">
      <div class="container">
        <div class="catogory_group">
          <div class="cat_title_wrap clearfix">
            <h1 class="right cat_title">{{ fields_acf.main_sale_title}}</h1>
          </div>
          <div class="cat_slide_wrap small-arrows">
            <div class="arrow_r ease">
              <a href="javascript:void(0);" @click.prevent="prev">
                <right-arrow></right-arrow>
              </a>
            </div>
            <div class="arrow_l ease">
              <a href="javascript:void(0);" @click="next">
                <left-arrow></left-arrow>
              </a>
            </div>
            <div class="cat_slide clearfix">
              <slick
                ref="slick"
                :options="slickOptions"
                @reInit="handleReInit"
                v-if="this.fields_acf.main_sale_products.length > 0"
              >
                <Product
                  v-bind:product="product"
                  v-bind:index="index"
                  v-for="(product, index) in this.fields_acf.main_sale_products"
                  :key="product.id"
                ></Product>
              </slick>
            </div>
          </div>
        </div>
      </div>
      <div class="bn_corner"></div>
    </section>
    <div class="cat_sales_tabs_m" v-if="categories && $mq == 'mobile'">
      <Slick
        class="m_cat_tabs_slide clearfix"
        ref="slick"
        @reInit="handleReInit"
        :options="mSlickOptions"
      >
        <div
          class="right m_cat_tab"
          v-bind:class="{active: activeCategory == cat.id}"
          v-for="(cat,index) in categories"
          :index="index"
          :key="index"
        >
          <a href="javascript:void(0);" @click.prevent="changeActive(cat.id)">
            <span class="table100">
              <span class="table_cell">{{cat.name}}</span>
            </span>
          </a>
        </div>
      </Slick>
    </div>
    <section class="inner_page">
      <div class="container">
        <div class="no_mobile" v-if="$mq !== 'mobile'">

          <category-item v-for="cat in categories" :key="cat.id" :category="cat" :onsale="onsale"></category-item>
        </div>
        <div class="mobile_only inner_page-sales">
          <h2 class="cat_title">{{activeTab.name}}</h2>
          <div class="row">
            <Product v-for="product in categoryProducts" :product="product" :key="product.id"></Product>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import LeftArrow from "../assets/img/arrow_l.svg";
import RightArrow from "../assets/img/arrow_r.svg";
import Product from "../components/Product/Product";
import CategoryItem from "../components/CategoryItem";
//import Slick from "vue-slick";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      activeCategory: "",
      topSaleProducts: [],
      // slickOptions: {
      //   prevArrow: $(this)
      //     .closest(".cat_slide_wrap")
      //     .find(".arrow_r"),
      //   nextArrow: $(this)
      //     .closest(".cat_slide_wrap")
      //     .find(".arrow_l"),
      //   slidesToShow: 6,
      //   slidesToScroll: 3,
      //   rtl: true,
      //   arrows: false,
      //   responsive: [
      //     {
      //       breakpoint: 1200,
      //       settings: {
      //         slidesToShow: 5
      //       }
      //     },
      //     {
      //       breakpoint: 800,
      //       settings: {
      //         slidesToShow: 4
      //       }
      //     }
      //   ]
      // },
      // mSlickOptions: {
      //   arrows: false,
      //   rtl: true,
      //   dots: false,
      //   infinite: true,
      //   centerMode: false,
      //   //slidesToShow: 3,
      //   variableWidth: true,
      //   slidesToScroll: 1,
      //   autoplay: false,
      //   autoplaySpeed: 3000
      // }
    };
  },
  methods: {
    // next() {
    //   this.$refs.slick.next();
    // },
    // prev() {
    //   this.$refs.slick.prev();
    // },
    // reInit() {
    //   //   this.$nextTick(() => {
    //   //     this.$refs.slick.reSlick();
    //   // });
    // },
    // changeActive(id) {
    //   let cat_id = id;
    //   this.activeCategory = cat_id;
    //   return;
    // },
    // handleReInit(event, slick) {
    //   this.reInit();
    // },
    // hasSaleProducts(cat_id) {
    //   var productsFound = this.products.filter(product => {
    //     return product.categories.indexOf(cat_id) !== -1;
    //   });
    //   productsFound = productsFound.filter(p => p.onsale);

    //   if (productsFound.length > 0) {
    //     return true;
    //   }
    //   return false;
    // }
  },
  mounted() {
    // this.$ajax({
    //   method: 'POST',
    //   url: homeUrl + 'ajax.php',
    //   params: {
    //     getProducts: '',
    //     ids: JSON.stringify(this.fields_acf.main_sale_products)
    //   }
    // }).then(res => {
    //   this.topSaleProducts = res.data;
    // })
    // setTimeout(() => {
    //   this.$nextTick(() => {
    //     this.$refs.slick.reSlick();
    //   });
    // }, 2000);
    // this.activeCategory = parseInt(this.categories[0].id);
  },
  computed: {
    ...mapState(["products"]),
    onsale: function() {
      return true;
    },
    mainSaleProducts: function() {
      let keys = Object.values(this.fields_acf.main_sale_products);
      let saleProducts = [];

      return this.products.filter(function(product) {
        return keys.includes(product.id);
      });
    },
    page: function() {
      return wpData.pageData;
    },
    fields_acf: function() {
      return this.page.acf;
    },
    // categories: function() {
    //   let indexToRemove = [];
    //   let cats = this.$store.state.categories.filter(function(category) {
    //     return category.parent != 0;
    //   });
    //   for (let index = 0; index < cats.length; index++) {
    //     const element = cats[index];
    //     if (!this.hasSaleProducts(element.id)) {
    //       cats.splice(index, 1);
    //     }
    //   }
    //   return cats;
    // },
    // activeTab() {
    //   let find = this.categories.find(cat => cat.id == this.activeCategory);
    //   if (typeof find != "undefined") {
    //     return find;
    //   }
    //   return false;
    // },
    // categoryProducts() {
    //   if (parseInt(this.activeCategory)) {
    //     let products = this.productsByCat[parseInt(this.activeCategory)];
    //     return products;
    //   }
    //   let first = this.productsByCat[parseInt(this.categories[0].id)];

    //   return first;
    // }
  },
  components: {
    LeftArrow,
    RightArrow,
    Product,
    // Slick,
    CategoryItem
  }
};
</script>

<style scoped>
</style>